import { render, staticRenderFns } from "./fssReturnDetail.vue?vue&type=template&id=60cd93b6&scoped=true&"
import script from "./fssReturnDetail.vue?vue&type=script&lang=js&"
export * from "./fssReturnDetail.vue?vue&type=script&lang=js&"
import style0 from "./fssReturnDetail.vue?vue&type=style&index=0&id=60cd93b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cd93b6",
  null
  
)

export default component.exports